import GroupSettings from './GroupSettings.page';

export default GroupSettings;